import { render, staticRenderFns } from "./FAQChartContainer.vue?vue&type=template&id=1aeae481&scoped=true&"
import script from "./FAQChartContainer.vue?vue&type=script&lang=js&"
export * from "./FAQChartContainer.vue?vue&type=script&lang=js&"
import style0 from "./FAQChartContainer.vue?vue&type=style&index=0&id=1aeae481&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aeae481",
  null
  
)

export default component.exports